import AntecipationRequest from '@/services/antecipation_request'

const getAntecipationRequest = (context, id) => {
  return new Promise((resolve, reject) => {
    AntecipationRequest.get(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  getAntecipationRequest
}



// WEBPACK FOOTER //
// ./src/features/antecipation_request/store/actions.js